// import 'babel-polyfill';
import app, { appIds } from "$$app";
import constants from "../../helpers/constants";
import log from '$$log';
import plansModel from "../../models/plans";

const __ = window.__;
const {
  controlViews: { ID_VIEW_TOOLBAR_BTN_CHAT },
  events: { ID_APP_EVENT_LIVECHAT_CLICK },
} = appIds;

const ID_KEY_STORAGE_CHAT_MISSING = "liveChatMissing";
const APP_EVENT_START = "app:start";
const APP_EVENT_SUPPORTCHAT_INIT = "init:supportChat";

const ID_APP_EVENT_SUPPORTCHAT_HIDE = "app:livechat:hide";
const ID_APP_EVENT_SUPPORTCHAT_SHOW = "app:livechat:show";

// Ключ для хранения ID последнего прочитанного сообщения
const ID_KEY_STORAGE_LAST_SEEN_MSG = "gp_livechat_last_seen_id";
let latestAgentMessageId = null;

var LC_API = LC_API || {};

let cwc = null;

window.LC_API = LC_API;

LC_API.on_after_load = function (data) {
  window.LC_API.disable_sounds();

  cwc = document.getElementById("chat-widget-container");
  cwc.style.display = "none";

  if (webix.storage.local.get(ID_KEY_STORAGE_CHAT_MISSING)) {
    // $$(ID_VIEW_TOOLBAR_BTN_CHAT).setValues({
    //   hasUnread: true
    // }, true);
  }

  app.on(ID_APP_EVENT_LIVECHAT_CLICK, () => {
    if (window.LC_API.chat_window_maximized()) {
      window.LC_API.minimize_chat_window();
    } else {
      window.LC_API.open_chat_window();
    }
  });
};

const innerObject = {
  init() {
    if (
      /** GT.siteConfig.indexOf('localhost') !== -1 || */
      app.config.mode.isHistory
    ) {
      return true;
    }

    // Инициализация виджета с новым JavaScript API (v2.0+)
    this.initWidget();
  },

  // Общая настройка конфигурации LiveChat
  setupLiveChatConfig() {
    window.__lc = window.__lc || {};
    window.__lc.license = 8254491;
    window.__lc.group = user && plansModel.getPlanId() === constants.PLANS.ENTERPRISE
      ? 6 // Enterprise группа
      : GT.locales.supported[user.locale].liveChatId;

    try {
      window.__lc.visitor = {
        name: user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : user.userName,
        email: user.email,
      };
      window.__lc.params = [
        { name: "Email", value: user.email },
        { name: "Registered", value: user.registrationTime },
        { name: "Current plan", value: plansModel.getSubscriptionName() || "Free" },
        { name: "Date to", value: plansModel.getExpiresDate() || "-" },
      ];
    } catch (e) {
      log.error('[LiveChat] Error setting visitor data:', e);
    }
  },

  initWidget() {
    // Настройка виджета с новым JavaScript API (v2.0+)
    // Документация: https://platform.text.com/docs/extending-chat-widget/javascript-api/
    this.setupLiveChatConfig();

    // Стандартный код отслеживания из документации (v2.0+)
    // Создает объект LiveChatWidget ДО загрузки скрипта
    if (app.config.mode.isBase) {
      (function (n, t, c) {
        function i(n) {
          return e._h ? e._h.apply(null, n) : e._q.push(n);
        }
        var e = {
          _q: [],
          _h: null,
          _v: "2.0",
          on() {
            i(["on", c.call(arguments)]);
          },
          once() {
            i(["once", c.call(arguments)]);
          },
          off() {
            i(["off", c.call(arguments)]);
          },
          get() {
            if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load.");

            return i(["get", c.call(arguments)]);
          },
          call() {
            i(["call", c.call(arguments)]);
          },
          init() {
            const n = t.createElement("script");

            n.async = !0;
            n.type = "text/javascript";
            n.src = "https://cdn.livechatinc.com/tracking.js";
            t.head.appendChild(n);
          },
        };

        if (!n.__lc.asyncInit) e.init();
        n.LiveChatWidget = n.LiveChatWidget || e;
      }(window, document, [].slice));

      setupNewAPIEvents();
    }
  },
};

// Настройка событий для нового JavaScript API (v2.0+)
// Документация: https://platform.text.com/docs/extending-chat-widget/javascript-api/
function setupNewAPIEvents() {
  if (!window.LiveChatWidget) {
    console.error("[LiveChat] LiveChatWidget object not found!");

    return;
  }

  const maxAttempts = 100; // 10 секунд
  let attempts = 0;

  // Ждем загрузки скрипта (_h !== null означает, что обработчик установлен)
  const checkWidget = setInterval(() => {
    attempts++;

    if (window.LiveChatWidget._h !== null) {
      clearInterval(checkWidget);
      setupEvents();

      return;
    }

    if (attempts >= maxAttempts) {
      clearInterval(checkWidget);
      if (window.LiveChatWidget) setupEvents();
    }
  }, 100);

  function setupEvents() {
    if (!window.LiveChatWidget || typeof window.LiveChatWidget.on !== "function") {
      return;
    }

    cwc = document.getElementById("chat-widget-container");
    if (cwc) {
      cwc.style.display = "none";
    }

    window.LiveChatWidget.on("ready", () => {
      //  console.log('[LiveChat] Widget ready (new API)');
    });

    window.LiveChatWidget.on("visibility_changed", data => {
      if (data.visibility === "maximized") {
        // Если открыли чат — помечаем последнее пойманное сообщение как прочитанное
        if (latestAgentMessageId) {
          webix.storage.local.put(ID_KEY_STORAGE_LAST_SEEN_MSG, latestAgentMessageId);
        }
        handleChatOpened();
      } else if (data.visibility === "minimized" || data.visibility === "hidden") {
        handleChatMinimized();
      }
    });

    window.LiveChatWidget.on("new_event", event => {
      if (event.type === "message" && event.author?.type === "agent") {
        const msgId = event.event_id || event.id || event.timestamp;

        try {
          const state = window.LiveChatWidget.get("state");
          const lastSeenId = webix.storage.local.get(ID_KEY_STORAGE_LAST_SEEN_MSG);

          if (!latestAgentMessageId || msgId > latestAgentMessageId) {
            latestAgentMessageId = msgId;
          }

          if (state.visibility === "maximized" && msgId) {
            webix.storage.local.put(ID_KEY_STORAGE_LAST_SEEN_MSG, msgId);
          }

          if (state.visibility === "minimized" && msgId && lastSeenId && msgId > lastSeenId) {
            app.trigger("app:livechat:new_message");
          }
        } catch (e) {
          log.error('[LiveChat] Error handling new_event:', e);
        }
      }
    });

    app.on(ID_APP_EVENT_LIVECHAT_CLICK, handleLiveChatClick);
  }

  function handleChatOpened() {
    if (!cwc) cwc = document.getElementById("chat-widget-container");
    if (cwc) {
      cwc.style.display = "block";
      cwc.style.bottom = "30px";
    }
    webix.storage.local.put(ID_KEY_STORAGE_CHAT_MISSING, false);
    app.trigger(ID_APP_EVENT_SUPPORTCHAT_SHOW);
  }

  function handleChatMinimized() {
    if (cwc) cwc.style.display = "none";
    app.trigger(ID_APP_EVENT_SUPPORTCHAT_HIDE);
  }

  function handleLiveChatClick() {
    if (!window.LiveChatWidget?.call) return;

    const state = window.LiveChatWidget.get("state");

    window.LiveChatWidget.call(state.visibility === "maximized" ? "minimize" : "maximize");
  }
}

const outputObject = {};

app.on(APP_EVENT_SUPPORTCHAT_INIT, () => {
  innerObject.init();
});

app.on(APP_EVENT_START, () => {
  innerObject.init();
});

LC_API.on_chat_window_opened = function () {
  if (!cwc) {
    window.LC_API.minimize_chat_window();

    return;
  }

  cwc.style.display = "block";
  cwc.style.bottom = "30px";

  webix.storage.local.put(ID_KEY_STORAGE_CHAT_MISSING, false);

  app.trigger(ID_APP_EVENT_SUPPORTCHAT_SHOW);
};

LC_API.on_chat_window_minimized = function () {
  cwc.style.display = "none";
  app.trigger(ID_APP_EVENT_SUPPORTCHAT_HIDE);
};

LC_API.on_chat_window_hidden = function () {
  cwc.style.display = "none";
  app.trigger(ID_APP_EVENT_SUPPORTCHAT_HIDE);
};

export default outputObject;
